<template>
	<div class="pb-5">
		<b-button class="filter" variant="light" block href="#" v-b-toggle.accordion-filter>
			<span><b-icon-funnel-fill></b-icon-funnel-fill> Filter</span>
			<span class="menu-arrow">
				<b-icon-chevron-right class="float-right chevron-right"></b-icon-chevron-right><b-icon-chevron-down class="float-right chevron-down"></b-icon-chevron-down>
			</span>
		</b-button>
		<b-collapse id="accordion-filter" accordion="accordion-filter" role="tabpanel" class="menu-accordion">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Name" label-for="filter-name" size="sm" :model.sync="filter.name" />
					<app-input-textarea id="fieldset-description" label-cols-sm="4" label-cols-lg="3" label="Description" label-for="filter-description" size="sm" :model.sync="filter.descriptionMultiple" />
					<b-button variant="danger" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
					<b-button variant="primary" size="sm" class="float-right mr-1" @click="getRoleManagements"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
		</b-collapse>
		<b-row class="mt-3">
			<b-col>
				<b-button variant="warning" v-if="(userRole != null ? userRole.allowUpdate : false)" class="float-right ml-2" @click="showPopupUploadData" size="sm"><b-icon-upload class="mr-1"></b-icon-upload> Upload</b-button>
				<b-overlay
					v-if="(userRole != null ? userRole.allowDownload : false)"
					:show="isDownloadDataBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowDownload : false)" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</b-overlay>
				<b-button variant="primary" v-if="(userRole != null ? userRole.allowDownload : false)" class="float-right" :href="`files/RoleManagement/RoleManagement.xlsx`" size="sm"><b-icon-wallet-fill class="mr-1"></b-icon-wallet-fill> Download Template</b-button>
			</b-col>
		 </b-row>
		<b-card class="mt-3 mb-3">
		<b-row class="mb-3">
			<b-col>
				<b-overlay
					v-if="(userRole != null ? userRole.allowCreate : false)"
					:show="isCreateBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="success" v-if="(userRole != null ? userRole.allowCreate : false)" @click="createData" size="sm"><b-icon-pencil class="mr-1"></b-icon-pencil> Create</b-button>
				</b-overlay>
				<b-overlay
					v-if="(userRole != null ? userRole.allowPrint : false)"
					:show="isMultiplePrintBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowPrint : false)" class="ml-2" @click="printData" size="sm"><b-icon-printer-fill class="mr-1"></b-icon-printer-fill> Multiple Print</b-button>
				</b-overlay>
			</b-col>
			<b-col>
				<span class="float-right">
					<b-form-select v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
			</b-col>
		</b-row>
		<div class="table-corner">
			<b-table id="my-table" stacked="md" head-variant="head-light"  :no-local-sorting="true" :items="roleManagements" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :tbody-tr-class="rowClass" small responsive>
			<template v-slot:head(actions)>
				<b-button-group class="float-right"  size="sm">
					<b-button @click="isShowFilter = !isShowFilter" size="sm"><b-icon-funnel-fill /></b-button>
					<b-button><b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right" v-model="selectAll"></b-form-checkbox></b-button>
				</b-button-group>
			</template>
			<template #top-row v-if="isShowFilter">
				<b-th></b-th>
				<b-th stacked-heading="Name">
					<b-form-input id="input-name-table" @input="getRoleManagementsWithoutLoading" v-model="filter.name" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Description">
					<b-form-input id="input-description-table" @input="getRoleManagementsWithoutLoading" v-model="filter.description" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Select All">
					<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
				</b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
			</template>
			<template v-slot:cell(actions)="row" >
				<div class="div-actions float-right">
				<b-button size="sm" v-if="(userRole != null ? userRole.allowUpdate : false)" @click="editData(row.index, row.item.id)" variant ="success"  class="mr-2 btn-xs">
					<b-icon-pencil></b-icon-pencil>
				</b-button>
				<b-overlay
					v-if="(userRole != null ? userRole.allowDelete : false)"
					:show="busy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<click-confirm>
					<b-button size="sm" variant="danger" @click="deleteData(row.item.id)" class="mr-2 btn-xs">
						<b-icon-trash></b-icon-trash>
					</b-button>
					</click-confirm>
				</b-overlay>
				<b-button size="sm" v-if="(userRole != null ? userRole.allowRead : false)" variant="primary" class="mr-2 mt-md-2 mt-lg-0 btn-xs" @click="showTableDetail(row.item.id)" >
					<b-icon-eye-fill></b-icon-eye-fill>
				</b-button>
				<b-button size="sm" v-if="(userRole != null ? userRole.allowPrint : false)" variant="light"  @click="printSingleData(row.item.id)" class="mr-2 mt-md-2 mt-lg-0 btn-xs">
					<b-icon-printer-fill></b-icon-printer-fill>
				</b-button>
				<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" class="d-inline" :id="'input-is-print-' + (row.index + 1)" @change="toggleIsPrint(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))" ></b-form-checkbox>
				</div>
			</template>
			</b-table>
		</div>
		<b-row>
			<b-col cols="12" md="6" lg="6">
				<b-overlay
					v-if="(userRole != null ? userRole.allowCreate : false)"
					:show="isCreateBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="success" v-if="(userRole != null ? userRole.allowCreate : false)" @click="createData" size="sm"><b-icon-pencil class="mr-1"></b-icon-pencil> Create</b-button>
				</b-overlay>
				<b-overlay
					v-if="(userRole != null ? userRole.allowPrint : false)"
					:show="isMultiplePrintBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowPrint : false)" class="ml-2" @click="printData" size="sm"><b-icon-printer-fill class="mr-1"></b-icon-printer-fill> Multiple Print</b-button>
				</b-overlay>
			</b-col>
			<b-col cols="12" md="6" lg="6">
			<b-pagination
				class="float-md-right btn-paging"
				v-model="currentPage"
				:total-rows="(roleManagementsPaging != null ? roleManagementsPaging.dataCount : 0)"
				:per-page="(roleManagementsPaging != null ? roleManagementsPaging.pageSize : 0)"
				aria-controls="my-table"
			></b-pagination>
			</b-col>
		</b-row>
		</b-card>
		<Upload
		:openPopup="showPopupUpload"
		@resetMethod="resetModalUpload"
		@uploadButtonMethod="uploadData"
		/>
		<PopupDownload
		:openPopup="showPopupDownload"
		:processId="processId"
		@resetModalMethod="resetModal"
		label= "Popup Download"
		:contentLabel = "popupDownloadLabel"
		/>
		<PopupPDF
		:openPopup="isShowPopupPDF"
		:pdfUrl="pdfUrl"
		@resetModalMethod="resetModal"
		label= "Popup PDF"
		/>
		
	<b-card class="mb-3" header-bg-variant="transparent" v-if="isShowTableRoleManagementDetail">
		<template #header>
			<b-row>
				<b-col cols="9"><h5 class="card-title font-weight-bolder text-dark">Role Management Detail</h5></b-col>
				<b-col>
					<span class="float-right">
						<button class="close" no-variant @click="isShowTableRoleManagementDetail = false">×</button>
					</span>
				</b-col>
			</b-row>
		</template>
		<b-row class="mb-2">
			<b-col>
				<span class="float-right">
					<b-form-select v-model="roleManagementDetailPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
			</b-col>
		</b-row>
		<b-row>
		<b-col>
			<div class="table-corner table-row-selected">
			<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="roleManagementDetails" :fields="fieldsRoleManagementDetail" :busy="isDataLoading" :sort-by.sync="sortByRoleManagementDetail" :sort-desc.sync="sortDescRoleManagementDetail" small responsive>
			<!--APP_TABLE_FILTER-->
			<template v-slot:head(actions)>
				<b-button @click="isShowRoleManagementDetailFilter = !isShowRoleManagementDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template>
			<template #top-row v-if="isShowRoleManagementDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Function Info">
					<v-select append-to-body label="name" :options="functionInfos" :value="filterRoleManagementDetail.functionInfoId" :reduce="item => item.id" v-model="filterRoleManagementDetail.functionInfoId" @search="getFunctionInfos" :filterable="true"  @focus="getFunctionInfos"></v-select>
				</b-th>
				<b-th stacked-heading="Allow Create">
					<b-form-checkbox id="input-allow-create-table" class="float-right" v-model="filterRoleManagementDetail.allowCreate"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Read">
					<b-form-checkbox id="input-allow-read-table" class="float-right" v-model="filterRoleManagementDetail.allowRead"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Update">
					<b-form-checkbox id="input-allow-update-table" class="float-right" v-model="filterRoleManagementDetail.allowUpdate"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Delete">
					<b-form-checkbox id="input-allow-delete-table" class="float-right" v-model="filterRoleManagementDetail.allowDelete"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Show In Menu">
					<b-form-checkbox id="input-show-in-menu-table" class="float-right" v-model="filterRoleManagementDetail.showInMenu"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Download">
					<b-form-checkbox id="input-allow-download-table" class="float-right" v-model="filterRoleManagementDetail.allowDownload"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Print">
					<b-form-checkbox id="input-allow-print-table" class="float-right" v-model="filterRoleManagementDetail.allowPrint"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Upload">
					<b-form-checkbox id="input-allow-upload-table" class="float-right" v-model="filterRoleManagementDetail.allowUpload"></b-form-checkbox>
				</b-th>
				<b-th></b-th>
			</template>
			<!--END_APP_TABLE_FILTER-->
			<!--APP_TABLE_DATA-->
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( roleManagementDetailPageSize * (currentRoleManagementDetailPage - 1))) }}
			</template>
			<template v-slot:cell(roleManagement)="row">
				{{ row.item.roleManagement != null ? row.item.roleManagement.name : "" }}
			</template>
			<template v-slot:cell(functionInfo)="row">
				{{ row.item.functionInfo != null ? row.item.functionInfo.name : "" }}
			</template>
			<!--END_APP_TABLE_DATA-->
			</b-table>
			</div>
		</b-col>
		<b-col cols="12">
			<!--APP_TABLE_PAGINATION-->
			<b-pagination
			class="float-right btn-paging"
			v-model="currentRoleManagementDetailPage"
			:total-rows="totalRoleManagementDetailRow"
			:per-page="roleManagementDetailPageSize"
			aria-controls="my-table"
			></b-pagination>
			<!--END_APP_TABLE_PAGINATION-->
		</b-col>
		</b-row>
	</b-card>
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';
</style>
<script>
import RoleManagement from '@/models/RoleManagement/RoleManagement';
import RoleManagementList from '@/models/RoleManagement/RoleManagementList';
import RoleManagementFilter from '@/filters/RoleManagement/RoleManagementFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import FunctionInfo from '@/models/Core/FunctionInfo';
import FunctionInfoFilter from '@/filters/Core/FunctionInfoFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import RoleManagementDetail from '@/models/RoleManagement/RoleManagementDetail';
import RoleManagementDetailFilter from '@/filters/RoleManagement/RoleManagementDetailFilter';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {RoleManagement, RoleManagementList, RoleManagementFilter, AppInputTextbox,AppInputTextarea,PopupDownload,PopupPDF,Upload,PopupDataEditNotification,},
	data() {
		return {
			isShowTableDetail: false,
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : { "class" : "th-number"}}, 
				{"name": {}, "class" : "th-name", "label" : "Name", key: 'name', sortable: true}, 
				{"description": {}, "class" : "th-description", "label" : "Description", key: 'description', sortable: true}, 
				{"actions": { "class" : "th-actions", "label" : ""}}
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			modelId: "",
			roleManagements: [],
			roleManagementsPaging: {},
			fieldsRoleManagementDetail: [
				{"no" : {  "class" : "th-number" }},
				{"functionInfo": {},  "class" : "th-function-info", "label" : "Function Info", key: 'functionInfo', sortable: true}, 
				{"allowCreate": {},  "class" : "th-allow-create", "label" : "Allow Create", key: 'allowCreate', sortable: true}, 
				{"allowRead": {},  "class" : "th-allow-read", "label" : "Allow Read", key: 'allowRead', sortable: true}, 
				{"allowUpdate": {},  "class" : "th-allow-update", "label" : "Allow Update", key: 'allowUpdate', sortable: true}, 
				{"allowDelete": {},  "class" : "th-allow-delete", "label" : "Allow Delete", key: 'allowDelete', sortable: true}, 
				{"showInMenu": {},  "class" : "th-show-in-menu", "label" : "Show In Menu", key: 'showInMenu', sortable: true}, 
				{"allowDownload": {},  "class" : "th-allow-download", "label" : "Allow Download", key: 'allowDownload', sortable: true}, 
				{"allowPrint": {},  "class" : "th-allow-print", "label" : "Allow Print", key: 'allowPrint', sortable: true}, 
				{"allowUpload": {},  "class" : "th-allow-upload", "label" : "Allow Upload", key: 'allowUpload', sortable: true}, 
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			filterRoleManagementDetail : null,
			currentRoleManagementDetailPage : 1,
			roleManagementDetailPageSize: 10,
			sortByRoleManagementDetail: '',
			sortDescRoleManagementDetail: '',
			sortingByRoleManagementDetail: [],
			roleManagementDetails : [],
			roleManagementDetailId : '',
			totalRoleManagementDetailRow : 0,
			isShowRoleManagementDetailFilter: false,
			isShowTableRoleManagementDetail: false,
			functionInfos: [],
		}
	},
	methods : {
		getRoleManagements : async function() {
			this.hideAllTableDetail();
			this.modelId = '';
			this.resetChildFilter();
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			RoleManagement.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.roleManagements = result.data
					this.roleManagementsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getRoleManagementsWithoutLoading : async function() {
			this.hideAllTableDetail();
			this.modelId = '';
			this.resetChildFilter();
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			RoleManagement.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.roleManagements = result.data
					this.roleManagementsPaging = result
				}
			})
			.catch(error => {});
		},
		/*APP_DETAIL_GETFUNCTIONINFO*/
		getFunctionInfos : async function(input) {
			let filter = new FunctionInfoFilter();
			if (input != undefined) {
				filter.name = input;
			}
			FunctionInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.functionInfos = result.data
				}
			})
			.catch(error => {});
		},
		/*END_APP_DETAIL_GETFUNCTIONINFO*/
		/*APP_DETAIL_GETRoleManagementDetail*/
		getRoleManagementDetails : async function() {
			let filter = {};
			Object.assign(filter, this.filterRoleManagementDetail);
			if (this.modelId == null || this.modelId == undefined || this.modelId == '') return;
			if (!this.isShowTableRoleManagementDetail) return;
			filter.roleManagementId = this.modelId;
			this.sortingByRoleManagementDetail = Array();
			if (this.sortByRoleManagementDetail != null) {
				this.sortingByRoleManagementDetail[this.sortByRoleManagementDetail] = this.sortDescRoleManagementDetail;
			}
			let currentPage = (this.currentRoleManagementDetailPage - 1);
			RoleManagementDetail.getList(this, filter, this.sortingByRoleManagementDetail, currentPage , this.roleManagementDetailPageSize).then(result => {
				this.roleManagementDetails = result.data;
				this.totalRoleManagementDetailRow = result.dataCount;
			}).catch(error => {});
		},
		/*END_APP_DETAIL_GETRoleManagementDetail*/
		resetFilter() {
			this.filter = new RoleManagementFilter();
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getRoleManagements();
		},
		toggleIsPrint(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				RoleManagement.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			RoleManagement.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			if (this.sortBy != null) {
					this.sortingBy[this.sortBy] = this.sortDesc;
			}
			this.isDownloadDataBusy = true;
			RoleManagement.downloadData(this, this.filter, this.sortingBy).then(result => {
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			}).catch(error => { this.isDownloadDataBusy = false; })
		},
		createData() {
			this.isCreateBusy = true;
			RoleManagement.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'rolemanagementedit', params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			RoleManagement.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'rolemanagementedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},
		deleteData(id) {
			RoleManagement.deleteData(this, id).then(result => {
				if (result)
				{
					this.getRoleManagements();
				}
			})
		},
		showTableDetail(id) {
			this.showAllTableDetail();
			this.modelId = id;
			this.getRoleManagementDetails()
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return;
			if (item.id === this.modelId) {
			if (this.isShowTableRoleManagementDetail) {
				return 'table-row-selected';
			}
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},
		resetChildFilter() {
			this.filterRoleManagementDetail = new RoleManagementDetailFilter();
		},
		showAllTableDetail() {
			this.isShowTableRoleManagementDetail = true;
		},
		hideAllTableDetail() {
			this.isShowTableRoleManagementDetail = false;
		},
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new RoleManagementFilter();
		this.filterRoleManagementDetail = new RoleManagementDetailFilter();
		this.getFunctionInfos();
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Role Management"
		];
		this.getRoleManagements();
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
		});
	},
	watch: {
		sortBy: {
			handler: function() {
				this.getRoleManagements();
			}
		},
		sortDesc: {
			handler: function() {
				this.getRoleManagements();
			}
		},
		currentPage: {
			handler: function() {
				this.getRoleManagements();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getRoleManagements();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				RoleManagement.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "rolemanagement") {
					this.getRoleManagementsWithoutLoading();
				}
			}
		},
		modelId: {
			handler: function() {
				this.resetChildFilter();
			}
		},
		/*APP_DETAIL_WATCH_ROLEMANAGEMENTDETAIL*/
		sortByRoleManagementDetail : {
			handler: function() {
				this.getRoleManagementDetails();
			}
		},
		sortDescRoleManagementDetail: {
			handler: function() {
				this.getRoleManagementDetails();
			}
		},
		currentRoleManagementDetailPage: {
			handler: function() {
				this.getRoleManagementDetails();
			}
		},
		roleManagementDetailPageSize : {
			handler: function() {
				this.getRoleManagementDetails();
			}
		},
		computedFilterRoleManagementDetail: {
			handler: function(newValue, oldValue) {
				if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
					this.getRoleManagementDetails();
				}
			},
			deep: true,
		},
		/*END_APP_DETAIL_WATCH_ROLEMANAGEMENTDETAIL*/
	},
	computed: {
		/*APP_DETAIL_COMPUTED_ROLEMANAGEMENTDETAIL*/
		computedFilterRoleManagementDetail(){
			return Object.assign({}, this.filterRoleManagementDetail);
		},
		/*END_APP_DETAIL_COMPUTED_ROLEMANAGEMENTDETAIL*/
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "role_management").first();
		}
	},
	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
